'use strict';

export class init {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
    }

    bindHandlers() {
        let _this = this;

        $(document).on('click', '.tariff-activation-btn', function (e) {
            e.preventDefault();

            let btn = $(this);
            $.post(_this.opt.activationPath, {
                serviceOrderId: btn.attr('data-service-order-id'),
                checkActiveTariffs: btn.attr('data-check-active-tariffs')
            }).done(function (data) {
                if (data.message === 'user-has-active-tariff') {
                    $('body').append(data.popup);
                } else if (data.popupSuccess) {
                    $('body').append(data.popupSuccess);
                }
            });
        });
    }
}